import { NavLink, useLocation } from 'react-router-dom';
import { haptics } from '../telegram';
import { HomeIcon, ChartIcon, CalendarIcon, UserIcon } from './icons';
import { TicketIcon } from './qualification/icons';

const QualIcon = () => <TicketIcon size={22} />;

const tabs = [
  { to: '/', label: 'Главная', Icon: HomeIcon },
  { to: '/leaderboard', label: 'Рейтинг', Icon: ChartIcon },
  { to: '/qualification', label: 'Отбор', Icon: QualIcon },
  { to: '/schedule', label: 'Турниры', Icon: CalendarIcon },
  { to: '/profile', label: 'Профиль', Icon: UserIcon },
];

export function TabBar() {
  const pathname = useLocation().pathname;
  // Свои достижения живут под профилем (K1: таб-бар с активным «Профилем»).
  const inAchievements = pathname.startsWith('/achievements');
  // Профиль игрока открывается из лидерборда (R2-4: активный таб — «Рейтинг»).
  const inPlayerProfile = /^\/players\/\d+$/.test(pathname);
  // Подэкраны отбора (моя позиция, профиль игрока отбора) держат таб «Отбор»
  // активным сами (prefix-match NavLink), доп. алиасов не нужно.
  return (
    <nav className="tabbar">
      {tabs.map(({ to, label, Icon }) => (
        <NavLink
          key={to}
          to={to}
          end={to === '/'}
          onClick={() => haptics.tap()}
          className={({ isActive }) =>
            isActive ||
            (to === '/profile' && inAchievements) ||
            (to === '/leaderboard' && inPlayerProfile)
              ? 'active'
              : ''
          }
        >
          <span className="ico">
            <Icon />
          </span>
          <span>{label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
